import { render, staticRenderFns } from "./bankCustomer.vue?vue&type=template&id=4b74cd74&"
import script from "./bankCustomer.vue?vue&type=script&lang=js&"
export * from "./bankCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports